export default __webpack_public_path__ + "static/media/Waleed Memoji Laptop White.fw.dfd47e82.png";